// The slide number of the built-in styles, and the classes a theme's corner items take, legible on a background
// picture (SA, group 0): see chromeRead.ts.

import type { SlideBg } from "../../../../shared/slideDesign";
import { cx } from "../../../lib/util";
import { spotLook, useSpotReads, type SpotRead } from "./chromeRead";

/** The classes for a corner's items on a picture: on dark or on light ink, and backed where the patch is busy. */
export function spotClasses(r: SpotRead | undefined): string[] {
  const l = spotLook(r);
  if (!l) return [];
  return [l.dark ? "sa-on-dark" : "sa-on-light", ...(l.backed ? ["sa-backed"] : [])];
}

/** A built-in style's slide number, bottom right, read against a background picture behind it. */
export function SlideNo({ number, ground }: { number: number; ground?: SlideBg | null }) {
  const reads = useSpotReads(ground);
  return <span className={cx("sl-no", ...spotClasses(reads?.br))}>{number}</span>;
}
